"use client";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarBlank, X } from "@phosphor-icons/react";

const schedule = [
  {
    date: "05",
    day: "Saturday",
    month: "July 2025",
    course: "CFA Prep",
    time: "10:00 AM - 12:00 PM",
  },
  {
    date: "06",
    day: "Sunday",
    month: "July 2025",
    course: "FRM Part-1",
    time: "10:00 AM - 12:00 PM",
  },
  {
    date: "12",
    day: "Saturday",
    month: "July 2025",
    course: "CFA Prep",
    time: "10:00 AM - 12:00 PM",
  },
  {
    date: "13",
    day: "Sunday",
    month: "July 2025",
    course: "FRM",
    time: "10:00 AM - 12:00 PM",
  },
  {
    date: "19",
    day: "Saturday",
    month: "July 2025",
    course: "CFA Prep",
    time: "10:00 AM - 12:00 PM",
  },
  {
    date: "20",
    day: "Sunday",
    month: "July 2025",
    course: "CFA Prep",
    time: "10:00 AM - 12:00 PM",
  },
];

const ClassSchedule = () => {
  const [showDrawer, setShowDrawer] = useState(false);

  const ScheduleContent = () => (
    <div className="space-y-3 p-4 bg-transparent w-full">
      {schedule.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-center px-4 py-3 rounded-lg shadow-sm bg-gray-50 hover:bg-blue-100 transition cursor-pointer"
        >
          <div>
            <p className="text-2xl font-bold text-gray-800 leading-none">
              {item.date}
            </p>
            <p className="text-sm text-gray-500">{item.month}</p>
            <p className="text-xs text-gray-400">{item.day}</p>
          </div>
          <div className="text-right">
            <p className="text-lg font-medium text-[#0D6FEA]">{item.course}</p>
            <p className="text-xs text-gray-600">{item.time}</p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <section className="hidden lg:block w-[30%] border mt-15 mr-10 border-gray-200 rounded-xl shadow-lg">
        <h2 className="text-3xl font-bold px-4 pt-2 text-[#0D6FEA]">
          July 2025:
        </h2>
        <div className="w-full flex justify-center">
          <ScheduleContent />
        </div>
      </section>

      <button
        onClick={() => setShowDrawer(true)}
        className="lg:hidden fixed top-20 -right-10 z-9 bg-[#0D6FEA] text-white px-3 py-2 pr-12 rounded-full shadow-lg flex items-center gap-2 text-sm"
      >
        <CalendarBlank size={20} />
        Calender
      </button>

      <AnimatePresence>
        {showDrawer && (
          <>
            <motion.div
              className="fixed inset-0 bg-transparent bg-opacity-30 z-40"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowDrawer(false)}
            />

            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.3 }}
              className="fixed right-0 top-18 h-full w-[90vw] sm:w-[70vw] bg-white z-50 shadow-lg flex flex-col"
            >
              <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                <h2 className="text-xl font-bold text-[#0D6FEA]">July 2025</h2>
                <button onClick={() => setShowDrawer(false)}>
                  <X size={24} />
                </button>
              </div>

              <div className="overflow-y-auto p-4">
                <ScheduleContent />
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default ClassSchedule;
